import { TransfersOtherBanksModule } from './../transfers-other-banks/transfers-other-banks.module';
import { TransferConfirmationComponent } from './transfer-confirmation/transfer-confirmation.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextMaskModule } from 'angular2-text-mask';

import { TransfersOmniComponent } from './transfers-omni.component';
import { TransfersToOmniComponent } from './transfers-to-omni/transfers-to-omni.component';
import { FavoredDataOmniComponent } from './favored-data-omni/favored-data-omni.component';
import { CurrencyMaskModule } from 'ngx-currency-mask';
import { MatDatepickerModule, MatCheckboxModule, MatButtonModule, MatListModule,
	MatRadioModule, MatSelectModule, MatAutocompleteModule, MatTabsModule } from '@angular/material';

import { NgxMaskModule } from 'ngx-mask';
import { RouterModule } from '@angular/router';
import { TransfersOmniService } from './transfers-omni.service';
import { TransferResultComponent } from './transfer-result/transfer-result.component';
import { SecurityCheckComponent } from './security-check/security-check.component';
import { MatTableModule } from '@angular/material/table';
import { ReceiptsModule } from '../receipts/receipts.module';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		MatDatepickerModule,
		CurrencyMaskModule,
		NgxMaskModule.forRoot(),
		MatCheckboxModule,
		MatButtonModule,
		MatListModule,
		MatRadioModule,
		FormsModule,
		ReactiveFormsModule,
		ReceiptsModule,
		RouterModule,
		MatSelectModule,
		MatAutocompleteModule,
		TransfersOtherBanksModule,
		TextMaskModule,
		MatTabsModule,
		MatTableModule
	],
	declarations: [
		TransfersOmniComponent,
		FavoredDataOmniComponent,
		TransfersToOmniComponent,
		SecurityCheckComponent,
		TransferConfirmationComponent,
		TransferResultComponent
	],
	exports: [
		TransfersOmniComponent
	],
	providers: [
		TransfersOmniService
	]
})
export class TransfersOmniModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/transfers-omni/transfers-omni.module.ts